import { isNullOrUndefined } from '@coveo/bueno';
import { isEmptyString } from './utils.js';
/**
 * Highlight the passed string using specified highlights.
 */
export function highlightString(params) {
    if (isEmptyString(params.openingDelimiter) ||
        isEmptyString(params.closingDelimiter)) {
        throw Error('delimiters should be a non-empty string');
    }
    if (isNullOrUndefined(params.content) || isEmptyString(params.content)) {
        return params.content;
    }
    if (params.highlights.length === 0) {
        return escapeHtml(params.content);
    }
    const maxIndex = params.content.length;
    let highlighted = '';
    let last = 0;
    for (let i = 0; i < params.highlights.length; i++) {
        const highlight = params.highlights[i];
        const start = highlight.offset;
        const end = start + highlight.length;
        if (end > maxIndex) {
            break;
        }
        highlighted += escapeHtml(params.content.slice(last, start));
        highlighted += params.openingDelimiter;
        highlighted += escapeHtml(params.content.slice(start, end));
        highlighted += params.closingDelimiter;
        last = end;
    }
    if (last !== maxIndex) {
        highlighted += escapeHtml(params.content.slice(last));
    }
    return highlighted;
}
/**
 * Highlight a suggestion with the given delimiters.
 * @param suggestion The suggestion to highlight
 * @param options The object contaning the delimiters used
 */
export function getHighlightedSuggestion(suggestion, options) {
    suggestion = escapeHtml(suggestion);
    return suggestion.replace(/\[(.*?)\]|\{(.*?)\}|\((.*?)\)/g, (part, notMatched, matched, corrected) => {
        if (notMatched) {
            return suggestionWithDelimiters(notMatched, options.notMatchDelimiters);
        }
        if (matched) {
            return suggestionWithDelimiters(matched, options.exactMatchDelimiters);
        }
        if (corrected) {
            return suggestionWithDelimiters(corrected, options.correctionDelimiters);
        }
        return part;
    });
}
function suggestionWithDelimiters(suggestion, delimiters) {
    if (delimiters) {
        return delimiters.open + suggestion + delimiters.close;
    }
    return suggestion;
}
/**
 * Escapes a string. For more information, refer to {@link https://underscorejs.org/#escape}
 *
 * @param str The string to escape
 */
export function escapeHtml(str) {
    const mapOfCharToEscape = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#x27;',
        '`': '&#x60;',
    };
    const source = `(?:${Object.keys(mapOfCharToEscape).join('|')})`;
    const testRegexp = RegExp(source);
    const replaceRegexp = RegExp(source, 'g');
    return testRegexp.test(str)
        ? str.replace(replaceRegexp, (substring) => mapOfCharToEscape[substring])
        : str;
}
